import React from 'react'
export function testXml(mesures){
    return (
        <xml>
            <titre>test</titre>
            <od_tension>{mesures.od_tension}</od_tension>
        </xml>
    )
}